import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  data: [],
  oneData: null,
  message: ''
};

export const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {
    addBanner: (state) => {
      state.loading = true;
    },
    getBanner: (state) => {
      state.loading = true;
    },
    getOneBanner: (state) => {
      state.loading = true;
    },
    successBanner: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    successOneBanner: (state, action) => {
      state.loading = false;
      state.oneData = action.payload;
    },
    removeBanner: (state) => {
      state.loading = true;
    },
    updateBanner: (state) => {
      state.loading = true;
    },
    failedBanner: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  },
});

export const { 
  addBanner, 
  removeBanner, 
  updateBanner, 
  getBanner, 
  successBanner, 
  getOneBanner,
  successOneBanner,
  failedBanner 
} = bannerSlice.actions;

export default bannerSlice.reducer;